var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var I18NController = /** @class */ (function () {
    function I18NController() {
    }
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/i18n/{lng}/{ns}" and http method "GET" to call the back-end.
    
        * @param {string} lng
        * @param {string} ns
        * @returns {{ [key: string]: string; }}
    ******************************************************************************************************/
    I18NController.Get = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/i18n/{lng}/{ns}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/i18n/{lng}" and http method "GET" to call the back-end.
    
        * @param {string} lng
        * @returns {{ [key: string]: { [key: string]: string; }; }}
    ******************************************************************************************************/
    I18NController.GetLng = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/i18n/{lng}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/i18n/{lng}/{ns}" and http method "POST" to call the back-end.
    
        * @param {string} lng
        * @param {string} ns
        * @param {KVP[]} list
        * @returns {Translation}
    ******************************************************************************************************/
    I18NController.PostNew = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/i18n/{lng}/{ns}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.list
        });
    };
    /*****************************************************************************************************
        * Is using route "api/i18n" and http method "POST" to call the back-end.
    
        * @param {Translation} trans
        * @returns {Translation}
    ******************************************************************************************************/
    I18NController.PostTrans = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/i18n", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.trans
        });
    };
    /*****************************************************************************************************
        * Is using route "api/i18n/namespaces" and http method "GET" to call the back-end.
    
        * @returns {string[]}
    ******************************************************************************************************/
    I18NController.GetAllNS = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/i18n/namespaces", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/i18n" and http method "GET" to call the back-end.
    
        * @returns {Translation[]}
    ******************************************************************************************************/
    I18NController.GetAll = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/i18n", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/i18n/language" and http method "POST" to call the back-end.
    Create a possible language from the supplied data.
    
        * @param {LanguageUploadDto} language  New language entity
        * @returns {void}
    ******************************************************************************************************/
    I18NController.CreateLanguage = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/i18n/language", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.language
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/i18n/languages" and http method "GET" to call the back-end.
    Returns all language that are currently available.
    
        * @returns {LanguageDownloadDto[]} List of all languages
    ******************************************************************************************************/
    I18NController.GetAllLanguages = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/i18n/languages", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/i18n/language/{lng}" and http method "GET" to call the back-end.
    Returns the language entity for the given language-code.
    
        * @param {string} lng  language code (ISO-639)
        * @returns {LanguageDownloadDto}
    ******************************************************************************************************/
    I18NController.GetLanguage = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/i18n/language/{lng}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/i18n/language/{lng}" and http method "DELETE" to call the back-end.
    Removes the language for the given language-code.
    
        * @param {string} lng  language code (ISO-639)
        * @returns {void}
    ******************************************************************************************************/
    I18NController.DeleteLanguage = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/i18n/language/{lng}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/i18n/language" and http method "PATCH" to call the back-end.
    Updates the language corresponding to the language code inside the given data.
    
        * @param {LanguageUploadDto} language  The language entity
        * @returns {void}
    ******************************************************************************************************/
    I18NController.UpdateLanguage = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/i18n/language", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.language
        });
    };
    return I18NController;
}());
export { I18NController };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=I18NController.js.map